import { useEffect } from 'react'
import loginService from './services/login'
import {
  Header,
  Main,
  Section,
  Footer,
} from './components/Layout'
import Blogs from './components/Blogs/Blogs'
import Notes from './components/Notes/Notes'
import { Notification } from './components/Notification'
import { useExpiringState } from './hooks/useExpiringState'
import { LoginForm } from './components/LoginForm'

const App = () => {
  const [user, setUser] = useExpiringState(
    null,
    60 * 60 * 1000
  )
  const [notification, setNotification] =
    useExpiringState(null)

  useEffect(() => {
    const loggedUserJSON =
      window.localStorage.getItem('loggedUser')
    if (loggedUserJSON) {
      const user = JSON.parse(loggedUserJSON)
      setUser(user)
      loginService.setToken(user.token)
      verifyUser()
    }
  }, [])

  const userLogin = async (username, password) => {
    try {
      const user = await loginService.login({
        username,
        password,
      })
      window.localStorage.setItem(
        'loggedUser',
        JSON.stringify(user)
      )
      loginService.setToken(user.token)
      setUser(user)

      setNotification({
        message: `Logged in as ${username}`,
        type: 'success',
      })
    } catch (error) {
      setNotification({
        message: error.response.data.error,
        type: 'error',
      })
    }
  }

  const userLogout = () => {
    window.localStorage.removeItem('loggedUser')
    loginService.setToken('Bearer ')
    setUser(null)

    setNotification({
      message: 'You logged out!',
      type: 'default',
    })
  }

  const verifyUser = async () => {
    const userToVerify = user
    // const userToVerify = {
    //   token:
    //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im1sdXVra2FpIiwiaWQiOiI2NDI4MjNjYWViZmRiODk1NGMyYzUwM2EiLCJpYXQiOjE2ODEyOTg0NDAsImV4cCI6MTY4MTMwMjA0MH0.-93Q4DCWctIAvSiockbuOVkkHONLU7UrfJmc-4YkYgo',
    //   username: 'mluukkai',
    //   name: 'Matti Luukkainen',
    //   id: '642823caebfdb8954c2c503a',
    // }

    //const userToVerify = null

    try {
      await loginService.verify(userToVerify)
    } catch (error) {
      setNotification({
        message: error.response.data.error,
        type: 'default',
      })
      window.localStorage.removeItem('loggedUser')
      loginService.setToken('Bearer ')
      setUser(null)
    }
  }

  return (
    <>
      <Notification notification={notification} />

      <Header title="Blogs & Notes">
        <LoginForm
          user={user}
          setUser={setUser}
          setNotification={setNotification}
          userLogin={userLogin}
          userLogout={userLogout}
        />
      </Header>

      <Main>
        <Section title="Blogs">
          <Blogs
            user={user}
            setNotification={setNotification}
          />
        </Section>

        <Section title="Notes">
          <Notes
            user={user}
            setNotification={setNotification}
          />
        </Section>
      </Main>
      <Footer />
    </>
  )
}

export default App
